import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterEntranceComponent } from './component/register-entrance.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportInfoPanelModule } from '@sdbn/common';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [RegisterEntranceComponent],
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,

    MatTooltipModule,
    MatSelectModule
  ]
})
export class RegisterEntranceModule { }
